import React from 'react';
import CommonDropdown from './outlinedDropdownField';
import PropTypes from 'prop-types';
import './forminputs.css';

class RenderCommonDropdownField extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      is_focus: false,
      changedLabel: null,
      wasTouched: false,
      isFocused: false,
      openDropdown: false
    };
  }

  onBlur = () => {
    let { wasTouched } = this.state;
    !wasTouched &&
      this.setState({
        wasTouched: true,
        isFocused: false,
        openDropdown: false
      });
  };
  onFocus = () => {
    this.setState({
      isFocused: true,
      wasTouched: false,
      openDropdown: true
    });
  };

  OpenDropdown = () => {
    // Explicitly focus the text input using the raw DOM API
    this.inputElement.open();
  };

  render() {
    const {
      getOptions,
      width,
      marginLeft,
      meta,
      wasTouched,
      labelClassName,
      maxWidth,
      isSingleRowField
    } = this.props;
    let { props } = this;
    let chekError = meta.error && wasTouched ? true : false;
    return (
      <div className="input-error-wrapper">
        <CommonDropdown
          labelClassName={labelClassName}
          width={width}
          maxWidth={maxWidth}
          isSingleRowField={isSingleRowField}
          chekError={chekError}
          marginLeft={marginLeft}
          {...props.input}
          enableThis={props.enableThis}
          emptyOnNotFound={props.emptyOnNotFound}
          getOptions={getOptions}
          id={props.id ? props.id.replace('_', '-') : props.input.name.replace(/_/g, '-')}
          fluid={props.fluid}
          staticValues={props.staticValues}
          bindToThisObject={props.bindToThisObject}
          dependedOnObject={props.dependedOnObject}
          placeholder={props.placeholder}
          url={props.url}
          onDropdownClose={props.onDropdownClose}
          onDropdownChange={props.onDropdownChange}
          onPreFilled={props.onPreFilled}
          selectOnClose={props.selectOnClose}
          disabled={props.disabled || props.showDisabledWithIcon}
          multiple={props.multiple}
          showImage={props.showImage}
          showCards={props.showCards}
          showLoader={props.showLoader}
          changeLabel={this.changeLabel}
          isCompact={props.isCompact}
          isUpward={props.isUpward}
          isSearchable={props.isSearchable}
          formName={props.meta.form}
          fieldName={props.input.name}
          code={props.code}
          dispatch={props.meta.dispatch}
          preselect_if_one_item={props.preselect_if_one_item}
          selectedLabel={props.selectedLabel}
          preselect_and_disable_if_one_item={props.preselect_and_disable_if_one_item}
          optional={props.optional}
          sort={props.sort}
          inputRef={(el) => (this.inputElement = el)}
          onBlur={this.onBlur}
          onFocus={this.onFocus}
          meta={props.meta}
          wasTouched={this.state.wasTouched}
          isFocused={this.state.isFocused}
          openDropdown={this.state.openDropdown}
          open={props.open}
          appendValue={props.appendValue}
          showLabel={props.showLabel}
          labelText={props.labelText}
          onOpen={props.onOpen}
          escapeSpecialCharFlag={props?.escapeSpecialCharFlag}
          onClick={props.onClick}
          onSearchChange={props.onSearchChange}
        />
      </div>
    );
  }
}

RenderCommonDropdownField.propTypes = {
  id: PropTypes.string,
  input: PropTypes.any,
  $noDropdownIcon: PropTypes.bool,
  bindToThisObject: PropTypes.any,
  placeholder: PropTypes.string,
  url: PropTypes.any,
  meta: PropTypes.any,
  getOptions: PropTypes.func,
  selectedLabel: PropTypes.string,
  staticValues: PropTypes.any,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  multiple: PropTypes.bool,
  onDropdownChange: PropTypes.func,
  onPreFilled: PropTypes.func,
  fluid: PropTypes.bool,
  optional: PropTypes.bool,
  sort: PropTypes.bool,
  enableThis: PropTypes.any,
  emptyOnNotFound: PropTypes.any,
  dependedOnObject: PropTypes.any,
  onDropdownClose: PropTypes.any,
  selectOnClose: PropTypes.any,
  showDisabledWithIcon: PropTypes.any,
  showImage: PropTypes.any,
  showCards: PropTypes.bool,
  showLoader: PropTypes.any,
  isCompact: PropTypes.any,
  isUpward: PropTypes.any,
  isSearchable: PropTypes.any,
  code: PropTypes.any,
  preselect_if_one_item: PropTypes.any,
  preselect_and_disable_if_one_item: PropTypes.any,
  errorMargin: PropTypes.any,
  width: PropTypes.number,
  marginLeft: PropTypes.any,
  wasTouched: PropTypes.any,
  labelClassName: PropTypes.string,
  appendValue: PropTypes.string,
  showLabel: PropTypes.bool,
  labelText: PropTypes.string,
  onOpen: PropTypes.func,
  escapeSpecialCharFlag: PropTypes.bool,
  maxWidth: PropTypes.string,
  isSingleRowField: PropTypes.bool,
  onClick: PropTypes.func,
  open: PropTypes.bool,
  onSearchChange: PropTypes.func
};

export default RenderCommonDropdownField;
